import React, { ReactNode } from 'react';
import '../styles/global.css';
import ThemeToggle from './ThemeToggle';

interface LayoutProps {
  children: ReactNode;
  title: string;
}

function Layout({ children, title }: LayoutProps) {
  return (
    <div className="app">
      <header className="hero-header">
        <div className="container">
          <h1>{title}</h1>
          <div className="theme-toggle-container">
            <ThemeToggle />
            </div>
        </div>
      </header>

      <main className="container">
        {children}
      </main>

      <footer className="site-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-info">
              <p>© {new Date().getFullYear()} My Abnormal Story</p>
              <p className="footer-tagline">
                Sharing alternative cancer treatment journeys to inspire hope
              </p>
            </div>
            <div className="footer-links">
              <a href="/" className="admin-link">Home</a>
              <a href="/about" className="admin-link">About Us</a>
              <a href="/privacy" className="admin-link">Privacy</a>
              <a href="/resources" className="admin-link">Resources</a>
              <a href="/analytics" className="admin-link">Analytics</a> 
              <a href="/admin-login" className="admin-link">Admin</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Layout;